/*========== LOGIN ACTIONS ============= */

export const login = ({ data, history }) => ({
  type: 'LOGIN',
  payload: data,
  history,
});

export const googleLogin = ({ data, history }) => ({
  type: 'GOOGLE_LOGIN',
  payload: data,
  history,
});

export const microsoftLogin = ({ data, history }) => ({
  type: 'MICROSOFT_LOGIN',
  payload: data,
  history,
});

export const appleLogin = ({ data, history }) => ({
  type: 'APPLE_LOGIN',
  payload: data,
  history,
});

export const onSignUp = ({ data, history }) => ({
  history,
  type: 'SIGNUP',
  payload: data,
});

export const toggleLogin = () => ({
  type: 'TOGGLE_LOGIN',
});

export const getDashboardStats = () => ({
  type: 'GET_DASHBOARD_STATS',
});

export const saveloginData = (payload) => ({
  payload,
  type: 'SAVE_LOGIN_DATA',
});

export const changePassword = ({ formData, successCallback, failCallback }) => ({
  type: 'CHANGE_PASSWORD',
  payload: { formData, successCallback, failCallback },
});

export const resetPassword = ({ formData, successCallback, failCallback }) => ({
  type: 'RESET_PASSWORD',
  payload: { formData, successCallback, failCallback },
});

export const forgotPassword = (payload) => ({
  payload,
  type: 'FORGOT_PASSWORD',
});

export const logout = () => ({
  type: 'LOGOUT'
});

export const revokeAllSessions = ({ successCallback, failCallback }) => ({
  type: 'REVOKE_ALL_SESSIONS',
  payload: { successCallback, failCallback }
});

export const revokeWorkspaceSessions = ({ workspaceId, successCallback, failCallback }) => ({
  type: 'REVOKE_WORKSPACE_SESSIONS',
  payload: { workspaceId, successCallback, failCallback }
});

export const setSocialPassword = (payload) => ({
  payload,
  type: 'SET_SOCIAL_PASSWORD',
});

export const toggle2FA = ({ enable, password, successCallback, failCallback }) => ({
  type: 'TOGGLE_2FA',
  payload: { enable, password, successCallback, failCallback },
});

export const verify2FA = ({ userId, otpCode, history, successCallback, failCallback }) => ({
  type: 'VERIFY_2FA',
  payload: { userId, otpCode },
  history,
  successCallback,
  failCallback,
});

/*========== Analytics Actions ============= */
export const getAnalytics = (payload) => ({
  payload,
  type: 'GET_ANALYTICS',
})

export const setAnalyticsRange = (payload) => ({
  payload,
  type: 'SET_ANALYTICS_RANGE',
})

export const getSearchResults = (payload) => ({
  payload,
  type: 'GET_SEARCH_RESULTS',
})
